(function(app) {

    app.constant("investmentKnowledges",
        [
            { Name: "Limited", Value: 0 },
            { Name: "Good", Value: 1 },
            { Name: "Extensive", Value: 2 } 
        ]);

})(window.app); //jshint ignore:line